import { Link } from 'react-router-dom'
import { DateTime } from 'luxon'
import './EventCard.css'

const EventCard = ({ event }) => {
  const type = event.type.toLowerCase()
  
  // Format date from database format (YYYY-MM-DD) to readable format
  // Stored data is in Asia/Dhaka timezone
  const formatEventDate = (dateString) => {
    if (!dateString) return 'Date TBA'
    
    try {
      // Parse date assuming it's in Asia/Dhaka timezone
      const date = DateTime.fromISO(dateString, { zone: 'Asia/Dhaka' })
      if (date.isValid) {
        return date.toFormat('LLLL d, yyyy') // e.g., "January 30, 2024"
      }
      return dateString
    } catch (error) {
      return dateString
    }
  }
  
  return (
    <div className={`event-card ${type}-card`}>
      <div className="event-header">
        <span className={`event-badge ${type}-badge`}>{event.type}</span>
        <span className={`event-status ${event.status.toLowerCase()}-status`}>
          {event.status}
        </span>
      </div>
      <h2 className="event-title">{event.title}</h2>
      <p className="event-subtitle">{event.subtitle}</p>
      
      <div className="event-meta">
        <div>
          <i className="fas fa-calendar"></i>
          {formatEventDate(event.date)}
        </div>
        {event.time && (
          <div>
            <i className="fas fa-clock"></i>
            {event.time}
          </div>
        )}
        <div>
          <i className="fas fa-map-marker-alt"></i>
          {event.location}
        </div>
        <div>
          <i className="fas fa-users"></i>
          {event.currentEnrollment}/{event.capacity} participants
        </div>
      </div>
      
      <div className="event-actions">
        <Link 
          to={`/${type}/${event.id}`} 
          className="cta-btn"
        >
          <span>View Details</span>
        </Link>
      </div>
    </div>
  )
}

export default EventCard

